<template>
  <span>
    <el-button type="danger"
               size="mini"
               @click="onStatisticalTotal">
      <slot></slot>
    </el-button>

    <el-dialog
        title="批量发布确认"
        :visible.sync="dialogVisible"
        width="30%">
      <span>共选任务:{{multipleSelection.length}},其中有效任务:{{validAmount}},请输入总金额{{salary}}</span>
      <br><br>
      <el-input v-model="inputSalary"
                placeholder="请输入总金额"></el-input>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false"
                   size="mini">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>

export default {
  components: {},
  props: {
    multipleSelection: Array,
  },
  data () {
    return {
      dialogVisible: false,
      validAmount: 0,
      salary: 0.00,
      inputSalary: null,
    }
  },
  methods: {
    onSubmit () {
      if (parseFloat(this.inputSalary) !== parseFloat(this.salary)) {
        this.$message.error('总金额输入错误，请重新提交')
        return false
      }

      let overTimeTask = this.multipleSelection.map((task) => {
        if (moment(task.taskendtime).isBefore(moment())) {
          return task.taskid
        }
      })

      overTimeTask = overTimeTask.filter(function (val) {
        return Boolean(val)
      })
      if (overTimeTask.length) {
        this.$message.error('任务结束时间必须晚于当前时间')
        return false
      }
      let multipleIds = {
        'task_ids': this.multipleSelection.map(item => item.taskid),
      }
      if (multipleIds.task_ids.length <= 0) {
        this.$message.error('请至少选择批量发布一个')
        this.dialogVisible = false
        return false
      }
      return request.alert('batchPublish', multipleIds).then((res) => {
        this.$message({
          showClose: true,
          message: '批量发布成功，成功' + res.data.success.length + '个,共' + multipleIds.task_ids.length + '个',
          type: 'success',
        })
        this.dialogVisible = false
        this.$store.commit('OPEN_LOADING')
        setTimeout(() => {
          this.$emit('clean')
          this.$store.commit('CLOSE_LOADING')
        }, 2000)
      })
    },
    onStatisticalTotal () {
      if (this.multipleSelection.length <= 0) {
        this.$message.error('最少选择一个任务发布')
        return false
      }
      let validAmount = 0
      let salary = 0.00
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (this.multipleSelection.hasOwnProperty(i)) {
          const it = this.multipleSelection[i]
          if (it.status === 0) {
            validAmount++
            salary = _.round(salary + (it.salary * it.hirenum), 2)
          }
        }
      }

      if (validAmount <= 0) {
        this.$message.error('没有要发布的任务，请重新选择')
        return false
      }
      this.validAmount = validAmount
      this.salary = salary
      this.dialogVisible = true
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/task/components/buttons/TaskBatchPublishButton.vue